
import React, { useEffect, useState } from "react";
import XLSX from 'xlsx'
import moment from 'moment-jalaali'
import { Form, Select } from 'antd';
// import DatePicker from 'react-datepicker2';
import DatePicker from "react-multi-date-picker";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import { usePersistedStore } from "../../store/persisted-store";
import { useReportsStore } from "../../store/slices/createReportsSlice";

export default function IssueEndorsementFilter(params) {
    const { getBranchNames, business } = usePersistedStore()
    const reports = useReportsStore();
    const [fromDate, setFromDate] = useState(null);
    const [toDate, setToDate] = useState(null);
    const branchNames = business.branchNames.data;
    const branchNamesLoading = business.branchNames.loading;
    const issueEndorsement = reports.issueEndorsement.data.DetailReport;
    const loading = reports.issueEndorsement.loading;

    useEffect(() => { getBranchNames() }, [])

    function convertToMoment(date) {
        return moment(date?.toDate()).format("YYYY-MM-DD");
    }

    function onFinish(values) {
        const params = {
            fromDate:  convertToMoment(fromDate), //moment(values.fromDate).format('YYYY/MM/DD'),
            toDate: convertToMoment(toDate), //moment(values.toDate).format('YYYY/MM/DD'),
            branchId: values.branch
        }
        reports.getIssueEndorsmentInfo({ param: params })
    }

    function downloadxlsx() {
        let data = issueEndorsement;
        if (!data) return
        let xlsxData = data.map(d => [
            d.Insurer,
            d.ApplicantFullName,
            d.PromoterFullName,
            d.BranchTitle,
            d.BusinessWageAmount,
            d.Amount,
            d.SumPayment,
            d.TaxAmount,
            d.SumDiscountAmount,
            d.ReturnToUser,
            d.CompanyName,
            d.EndorsementId,
            d.InsuranceRequestId,
            moment(d.IssueDate).format('jYYYY/jMM/jDD'),
        ])
        xlsxData.unshift(['نام بیمه گزار', 'نام کاربر', 'نام بازاریاب', 'رشته', 'کارمزد', 'مبلغ الحاقیه', 'مبلغ پرداختی', 'مبلغ مالیات', 'تخفیفات', 'عودت', 'شرکت بیمه', 'کدالحاقیه', 'کد الحاقیه', 'تاریخ صدور'])
        const worksheet = XLSX.utils.aoa_to_sheet(xlsxData);
        const new_workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(new_workbook, worksheet, "SheetJS");
        XLSX.writeFile(new_workbook, "bimeh[dot]com.xlsx")
    }

    return (
        <div>
            <Form
                className="sale-filter"
                initialValues={{
                    branch: params.branchId,
                    user: null,
                    fromDate: params.fromDate && moment(params.fromDate).subtract(1, 'months'),
                    toDate: params.toDate && moment(params.toDate)
                }}
                layout="inline" onFinish={onFinish}><Form.Item
                    name='branch'
                    label="رشته بیمه">
                    <Select
                        defaultValue={null}
                        loading={branchNamesLoading}
                        disabled={!branchNames?.length}
                        style={{ minWidth: 200 }}>
                        <Select.Option key="all" value={null}>همه رشته  بیمه ها</Select.Option>
                        {branchNames && branchNames?.filter(name => !name.Disabled)?.map(name => {
                            return <Select.Option key={name.Id} value={name.Id}>{name.Title}</Select.Option>
                        })}
                    </Select>
                </Form.Item>
                <Form.Item
                    name='fromDate'
                    label='از تاریخ'>
                    <DatePicker
                        value={fromDate}
                        onChange={setFromDate}
                        calendar={persian}
                        locale={persian_fa}
                        format="YYYY/MM/DD"
                        inputClass="datepicker-input"
                        calendarPosition="bottom-right"
                        portal
                        zIndex={1070}
                    />
                </Form.Item>
                <Form.Item
                    name='toDate'
                    label='تا تاریخ'>
                    <DatePicker
                        value={toDate}
                        onChange={setToDate}
                        calendar={persian}
                        locale={persian_fa}
                        format="YYYY/MM/DD"
                        inputClass="datepicker-input"
                        calendarPosition="bottom-right"
                        portal
                        zIndex={1070}
                    />
                </Form.Item>
                <Form.Item label="" colon={false}>
                    <button
                        style={{ float: "left", padding: "6px 24px", height: 40, }} disabled={loading} type="primary"
                        className="btn btn-primary waves-effect waves-light" >جستجو&nbsp;&nbsp;&nbsp;
                        <i className={loading ? "bx bx-loader bx-spin" : "fas fa-search"}></i>
                    </button>
                </Form.Item>
                <button type="primary" className="btn btn-success waves-effect waves-light float-left" disabled={!issueEndorsement}
                    onClick={downloadxlsx} style={{ marginRight: "10px" }}>
                    <i className="far fa-file-excel font-size-14 align-middle mr-2"></i> دریافت اکسل
                </button>
            </Form>
        </div>
    )
}